let selectedBulletinIds: string[] = [];

let onIdsUpdated: ((ids: string[]) => void) | null = null;

export const BulletinSelectionService = {
    setUpdateCallback(callback: (ids: string[]) => void) {
        onIdsUpdated = callback;
    },

    getSelectedBulletinIds(): string[] {
        return [...selectedBulletinIds];
    },

    getSelectedIdsList(ids: string[]): string[] | undefined {
        selectedBulletinIds = [...ids];

        if (onIdsUpdated) {
            onIdsUpdated(selectedBulletinIds);
        }

        return ids;
    }
};